import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const VerticalLarge = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="5px"
        height="490px"
        viewBox="0 0 2 320"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M1.6,316.6c0-0.4,0.1-0.8,0.1-0.9c-0.1-0.6,0-0.8,0.1-1c0.2-0.4,0.1-1.6,0.1-2.4c-0.3-1,0-2,0-3
		c0-0.6-0.1-1.4-0.1-1.9c0.1-1.5,0.1-3.1,0.1-4.5c0-1,0-1.5,0.2-2.1c-0.1-0.2-0.2-0.4-0.4-0.6c0.3-1.8,0.3-3.7,0.2-5.8
		c0.1-0.4,0.1-0.7,0.2-1.1c0-0.4-0.1-0.7-0.1-1.1c0-0.3-0.1-0.6-0.1-1.3c0.1-0.2,0.1-0.4,0.1-0.4c0-1.3-0.1-2.4-0.1-3.1
		c0.1-1.7,0-3.1,0-4.7c0-1.6-0.1-3.4,0.1-4.5c0-0.8-0.1-1.4-0.1-1.9c0-0.6,0.1-1.2,0.1-1.8c-0.1-0.4-0.2-1-0.1-2
		c0-0.7,0.1-1.3,0.1-2c0-1,0-2-0.1-2.4c0.1-0.9,0.1-1.6,0.2-2.3c-0.1-0.5-0.1-0.9-0.2-1.4c0.1-0.2,0.2-0.4,0.2-0.5
		c0-0.9,0-1.8-0.2-1.7c0-0.7,0-1.3,0-1.9c0-0.5,0-1,0-1.3c0.1-1.1,0.2-2.2,0-3.4c0-0.1,0-0.3,0-0.4c0.1-0.8,0-1.8,0-2.6
		c0-0.4,0.1-0.8,0.1-1.2c-0.1-1.4-0.1-1.4,0-4.5c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-2.2,0.2-4.4,0-6.6c0.1-1.6-0.1-3.6,0.1-4.7
		c0-0.8-0.1-1.5-0.1-2.1c0.1-0.4,0.1-0.8,0.2-1.2c-0.1-0.3-0.1-0.6-0.2-0.6c0-1.2,0.1-2.2,0-3.2c0-1.1,0-2.1,0.1-3
		c0-0.3,0-0.7,0.1-1.1c-0.1-0.1-0.1-0.2-0.2-0.3c0.1-1.1,0.1-2.1,0.2-3.1c0-0.1,0-0.3,0-0.4c-0.1-0.5-0.1-1.1-0.2-1.6
		c0-0.1,0.1-0.4,0.2-0.6c0-0.7-0.1-1.4-0.1-1.9c0-0.5,0.1-0.9,0.1-1.1c0-0.8-0.1-1.5-0.1-2.2c0.1-2.8,0-5.6,0.1-8.3
		c0-0.4,0-0.9,0-1.1c-0.2-1.7,0-3.7,0-5.4c0.2-1.3,0-2.1-0.1-3c0.2-1,0.3-2.1,0.1-3.5c0-0.2,0-0.6,0-0.9c0.1-1.5,0-2.5-0.2-3.4
		c0.1-0.3,0.2-0.5,0.2-0.6c-0.1-1.7,0-3.3,0-4.8c0-2-0.1-4.1,0-6.2c-0.1-1.3,0-2.4,0.1-3.5c0-0.4,0-1.2,0-1.3c-0.3-1.1-0.1-2,0-3
		c-0.1-1.9-0.1-2.1,0.2-2.3c-0.1-0.5-0.2-0.9-0.3-1.5c0.2-1.2-0.1-3.1,0.2-4.3c-0.1-0.3-0.2-0.6-0.3-0.8c0.1-1,0.2-1.8,0.3-2.7
		c-0.2-1.5,0-3.2-0.1-4.8c0,0-0.1,0-0.1,0c0-1.5,0-2.6,0.2-3.4c0-0.9-0.3-1.5-0.2-2.6c0.2-1.5-0.1-1.7-0.2-2.4
		c0.1-0.8,0.4-1.3,0.1-2.7c0.1-0.4,0.2-0.8,0.2-1.1c-0.1-0.9-0.1-1.4-0.1-2c0.1-0.2,0.1-0.5,0.1-0.6c-0.1-0.8-0.1-1.6-0.2-2.4
		c0.1-0.3,0.1-0.5,0.2-0.8c-0.1-0.5-0.1-0.9-0.2-1.6c0.1-0.3,0.2-0.5,0.2-0.8c-0.2-1.5-0.2-2.9-0.1-4.2c0.1-1.9,0.1-3.7,0-5.3
		c0-0.9,0-1.7,0.1-2.3c0.1-1-0.2-1.2-0.1-2.1c0.1-0.4,0.1-0.8,0.2-1.2c-0.1-0.8-0.2-1.4-0.2-2c0.1-0.9,0.1-1.8,0.2-2.8
		c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.5,0-0.9,0-1.4c0-0.5,0-1.1,0-1.6c0-1.1,0.2-2.2-0.1-3c0.1-1.2,0-2.8,0.1-4c0.1-0.5,0.1-1.1,0-1.3
		c-0.1-0.2-0.1-0.7-0.1-1.3c0-0.4-0.1-0.7-0.1-1c0-0.2,0.1-0.5,0.1-0.7c0-0.3,0.1-0.5,0.1-0.5c0-0.4-0.1-0.8-0.1-1.1
		c0-0.8,0.1-1.6,0.1-2.5c0-1.4,0-2-0.3-2.6c0,0,0-0.3,0-0.6c0.1,0,0.2,0.1,0.3,0.1c0-0.7,0-1.2-0.1-1.7c0-0.4-0.1-1,0-1.2
		c0-0.4,0.1-0.5,0.2-0.8c-0.1-0.7-0.2-1.4-0.3-2.2c0-0.7,0-1.5,0.1-2.3c0.1-1.9,0.1-1.9-0.1-3c0.2-0.7,0.2-1.9,0.1-2.8
		c-0.1-0.9,0-1.6,0-2.4c0-1.1,0.1-2.1,0-3.2c-0.1-0.7,0-1.3,0-1.9c0.1-1,0-1.5-0.1-1.8c-0.1-2.2,0.2-3.8,0.2-5.9
		c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1-1.7,0-2.5,0.2-3c-0.1-1-0.1-1.3-0.1-2.7c0-0.2,0-0.5,0-0.6c-0.2-0.8-0.1-1.6,0-2.4
		c0-0.4,0-1.4,0-1.5c-0.2-0.3-0.1-1.4-0.1-1.6c-0.2-1,0.1-1.5,0-2.3c0-0.8-0.1-1.6,0-2.6c0.1-0.5,0-1.9,0-2.8c0-1.2,0.1-2.1,0.1-3.2
		c-0.1-0.3-0.1-0.5-0.2-0.7c0.1-0.8,0.1-1.3,0.2-2c-0.3-0.8-0.2-2-0.1-3.4c0-0.6,0.1-1.2,0.1-1.9c-0.1,0.2-0.1,0.4-0.2,0.6
		c0-1,0-2.1,0.1-2.4c0.2-1.1,0.1-1.8,0-3c-0.1-1-0.1-2.5-0.1-3.8c0-0.6,0.1-1.2,0.2-1.8c-0.2-1.1-0.2-2-0.2-2.9
		c0.1-1.4,0.1-4.1,0-5.3c0-1,0-1.7,0.1-2c0,0,0-0.3,0.1-0.6c-0.1,0-0.1,0-0.2,0c0-1.7,0.1-3.3,0.1-4.4C1.7,2.6,1.7,2,1.6,1.5
		C1.5,1,1.4,0.1,1.3,0L1.2,1.9c0,1.2-0.1,2.8-0.1,4.6c0.1,0,0.1,0,0.2,0c0,0.3,0,0.6-0.1,0.6C1,7.4,1,8.2,1,9.2c0,0.5,0,1.3,0,2.2
		c0,0.1,0,0.3,0,0.5c0,0,0,0,0,0c0,1,0,2.1-0.1,2.8c0,0.9,0,1.8,0.2,3C1.1,18.2,1,18.9,1,19.5c0,1.3,0,2.9,0.1,3.9
		c0.1,1.3,0.2,2,0,3.1C1,26.9,1,28,1,29.1c0.1-0.2,0.2-0.4,0.2-0.6c0,0.8-0.1,1.4-0.1,2C1,31.9,1,33.2,1.3,34c0,0.1,0,0.2,0,0.3
		c0,0,0,0,0,0c0,0,0,0.2,0.1,0.5c-0.1,0.1-0.1,0.2-0.1,0.1c0,0,0,0,0-0.1c0,0.4-0.1,0.8-0.1,1.2c0.1,0.2,0.1,0.5,0.2,0.8
		c-0.1,1.1-0.2,2-0.1,3.3c0,1,0.1,2.4,0,2.9c-0.1,1-0.1,1.9,0,2.7c0,0.9-0.2,1.4,0,2.4c0,0.2-0.1,1.3,0.1,1.6c0,0,0,0.2,0,0.4
		c0-0.1,0.1-0.3,0.1-0.3c0,0,0,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4c0,0,0-0.1-0.1-0.2c0,0.3,0,0.7,0,0.9C1,52.2,1,53,1.1,53.9
		c0,0.1,0,0.4,0,0.6c0,1.5,0,1.8,0.1,2.8C1,57.9,0.9,58.7,1,60.4c0.1-0.2,0.1-0.3,0.2-0.5c0,2.2-0.3,3.9-0.2,6.1
		c0.2,0.3,0.2,0.8,0.1,1.9c0,0.6-0.1,1.2,0,1.9c0.1,1.1,0,2.2,0,3.3c0,0.8,0,1.6,0,2.5c0.1,1,0,2.3-0.1,2.9c0.2,1.1,0.2,1.1,0.1,3.1
		C1.1,82.5,1,83.3,1,84c0.1,0.8,0.2,1.5,0.3,2.3c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.2,0,0.8,0,1.3c0,0.5,0,1,0.1,1.8
		c-0.1,0-0.2-0.1-0.4-0.1c0,0.3,0,0.6,0,0.7c0.2,0.6,0.3,1.2,0.3,2.7c0,0.9-0.1,1.7-0.1,2.6c0,0.3,0,0.7,0.1,1.2
		c0,0.1-0.1,0.3-0.1,0.6c0,0.2-0.1,0.5-0.1,0.7c0,0.3,0.1,0.6,0.1,1c0,0.6,0,1.1,0.1,1.3c0.1,0.2,0.1,0.8,0,1.3
		c-0.2,1.2,0,2.9-0.1,4.1c0.2,0.8,0.1,2,0.1,3.1c0,0.5,0,1.1,0,1.7c0,0.5,0,0.9,0,1.4c0.1,0.3,0.1,0.6,0.2,0.9
		c-0.1,1-0.1,1.9-0.2,2.9c0.1,0.7,0.2,1.3,0.2,2.1c-0.1,0.4-0.1,0.8-0.2,1.2c-0.1,0.9,0.2,1.2,0.1,2.2c0,0.7,0,1.5-0.1,2.4
		c0.1,1.7,0.1,3.5,0,5.5c-0.1,1.3,0,2.9,0.1,4.4c-0.1,0.3-0.2,0.5-0.3,0.8c0.1,0.7,0.2,1.1,0.3,1.6c-0.1,0.4-0.1,0.6-0.2,0.9
		c0.1,0.8,0.1,1.7,0.2,2.5c0,0.1-0.1,0.3-0.1,0.6c0,0.6,0.1,1.1,0.1,2.1c-0.1,0.3-0.1,0.7-0.2,1.1c0,0,0,0,0,0.1
		c0.1-0.3,0.2-0.1,0.3,0.1c-0.1,0.2-0.1,0.4-0.2,0.5c0.1,0.9-0.1,1.4-0.2,2.1c0.1,0.7,0.3,0.8,0.2,2.4c-0.1,1.2,0.1,1.8,0.2,2.7
		c-0.2,0.8-0.3,2-0.2,3.5c0.1,0,0.1,0,0.1,0c0.1,1.6-0.2,3.4,0.1,5c-0.1,1-0.2,1.8-0.3,2.8c0.1,0.3,0.2,0.6,0.3,0.9
		c-0.2,1.3,0,3.3-0.2,4.5c0.1,0.5,0.2,1,0.3,1.5C1,170,1,170.3,1.2,172.2c-0.1,1-0.3,1.9,0,3.1c0,0.1,0,0.9,0,1.3
		c0,0.9-0.1,1.9-0.1,2.9c0,0.2,0,0.4,0,0.5c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c-0.1,2.2,0,4.3,0,6.4c0,1.6-0.1,3.3,0,5
		c0,0.1-0.1,0.4-0.2,0.6c0.1,1,0.3,2.1,0.2,3.6c0,0.3,0,0.7,0,0.9c0.2,1.4,0.1,2.5-0.1,3.6c0.1,0.9,0.4,1.7,0.1,3.1
		c0.1,1.8-0.2,3.8,0.1,5.6c0,0.2,0,0.8,0,1.2c-0.1,2.8,0,5.7-0.1,8.6c0,0.7,0.1,1.4,0.1,2.2c0,0.3-0.1,0.7-0.1,1.1
		c0,0.6,0,1.2,0.1,2c-0.1,0.2-0.1,0.5-0.2,0.6c0.1,0.6,0.1,1.1,0.2,1.7c0,0.1,0,0.3,0,0.4c-0.1,1-0.1,2.1-0.2,3.2
		c0.1,0.1,0.2,0.2,0.3,0.3c0,0.4,0,0.8-0.1,1.1c-0.1,1-0.1,2-0.1,3.1c0,1,0,2-0.1,3.3c0,0.1,0.1,0.3,0.2,0.7
		c-0.1,0.5-0.1,0.8-0.2,1.3c0,0.3,0,0.6,0.1,0.9c0-0.1,0-0.2,0.1-0.4c0,0.5,0,0.8,0,1.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.1,0,0.2
		c0.1-0.3,0.2,0.1,0.2,1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.5,0-0.8,0-1.1c-0.2,1.2,0,3.1-0.1,4.6c0.2,2.3,0.1,4.5,0,6.8
		c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,3.1-0.1,3.1,0,4.6c0,0.4-0.1,0.8-0.1,1.3c0,0.9,0.1,1.9,0,2.7c0,0.1,0,0.4,0,0.5
		c0.2,1.2,0.1,2.3,0,3.5c0,0.4,0,0.9,0,1.4c0,0.6,0,1.2,0,1.9c0.2-0.1,0.2,0.8,0.2,1.8c-0.1,0.1-0.1,0.3-0.2,0.5
		c0.1,0.6,0.2,1,0.2,1.5c-0.1,0.8-0.1,1.5-0.2,2.4c0.2,0.4,0.2,1.4,0.1,2.4c0,0.7-0.1,1.4-0.1,2.1c-0.1,1.1,0,1.7,0.1,2.1
		c0,0.6-0.1,1.3-0.1,1.9c0,0.6,0,1.2,0.1,2c-0.2,1.1-0.1,3-0.1,4.7c0,1.7,0.1,3.2,0,4.9c0,0.8,0,1.9,0.1,3.2c0,0-0.1,0.2-0.1,0.4
		c0.1,0.7,0.1,1,0.1,1.3c0,0.3,0.1,0.7,0.1,1.1c-0.1,0.4-0.1,0.7-0.2,1.1c0.1,2.1,0.1,4.2-0.2,6c0.1,0.2,0.2,0.4,0.4,0.7
		c-0.1,0.6-0.2,1.2-0.2,2.2c0,1.5,0.1,3.1-0.1,4.7c0,0.4,0,1.3,0.1,1.9c0,0.4,0,0.8-0.1,1.2c0,0,0.1,0,0.1,0
		c0.2-0.1,0.3-0.4,0.3-1.6c0-0.4,0.1-0.7,0.1-1.1C1.7,317.1,1.6,316.7,1.6,316.6z M1.2,12.8c0-1,0-1.5,0.2-1.2
		C1.3,12.2,1.3,12.4,1.2,12.8z M1.5,18.6c0-0.2,0-0.3,0-0.5c0,0.1,0,0.2,0.1,0.4c0,0.2,0,0.4-0.1,0.6C1.6,18.9,1.5,18.8,1.5,18.6z
		 M1.3,26.3c0,0,0-0.2,0-0.4c0,0,0.1-0.1,0.1-0.1c0,0.2,0,0.4,0,0.6C1.3,26.3,1.3,26.3,1.3,26.3z M1.3,31.8c0.2-0.3,0.2-0.3,0.2,0.9
		C1.4,32.4,1.4,32.2,1.3,31.8z M1.1,53.5c0,0,0-0.3-0.1-0.4c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0.2,0.1,0.4C1.2,53.4,1.1,53.6,1.1,53.5z
		 M1.5,56.4c0-0.2,0-0.4,0.1-0.6c0,0.2,0,0.3,0.1,0.6c0,0.2-0.1,0.4-0.1,0.5C1.6,56.7,1.5,56.5,1.5,56.4z M1.2,66.5
		c0-0.2-0.1-0.3-0.1-0.4c0-0.1,0-0.4,0.1-0.4c0,0,0,0.2,0.1,0.3C1.3,66.1,1.3,66.3,1.2,66.5z M1.3,143.8c-0.1-0.9,0-1.1,0.2-0.9
		C1.4,143.3,1.4,143.6,1.3,143.8z M1.4,183.6c0.1,0.3,0.2,0.7,0.1,1.8C1.5,185,1.3,184.8,1.4,183.6z"
            />
            <path
                fill={color}
                d="M0.6,147.3c0-0.2,0.1-0.5,0.2-0.9C0.6,146.2,0.6,146.4,0.6,147.3z"
            />
            <path
                fill={color}
                d="M0.7,188.5c-0.1,1.2,0,1.4,0.1,1.8C0.9,189.3,0.8,188.9,0.7,188.5z"
            />
            <path
                fill={color}
                d="M0.4,34.1c0,0.2,0,0.5,0,0.5c0,0,0.1-0.1,0.1-0.1c-0.1-0.3-0.1-0.5-0.1-0.5C0.5,33.8,0.5,34,0.4,34.1z"
            />
            <path fill={color} d="M0.6,31.3c0.1,0.3,0.1,0.6,0.2,1C0.8,31,0.8,31,0.6,31.3z" />
            <path
                fill={color}
                d="M0.6,25.2c0,0.1,0,0.4,0,0.4c0,0,0.1,0.1,0.1,0.1c0-0.2,0-0.4,0-0.6C0.7,25.1,0.6,25.1,0.6,25.2z"
            />
            <path
                fill={color}
                d="M0.9,17.1c0,0.2,0,0.4,0,0.5c0,0.2,0,0.3,0.1,0.5c0-0.2,0-0.3,0.1-0.6C0.9,17.3,0.9,17.2,0.9,17.1z"
            />
            <path
                fill={color}
                d="M0.9,56.1c0,0.2-0.1,0.4-0.1,0.6c0,0.1,0,0.3,0,0.5c0-0.2,0.1-0.3,0.1-0.5C1,56.4,0.9,56.3,0.9,56.1z"
            />
            <path
                fill={color}
                d="M0.5,66.4c0,0,0,0.3-0.1,0.4c0,0.1,0,0.3,0.1,0.4c0-0.2,0-0.4,0.1-0.5C0.6,66.6,0.6,66.4,0.5,66.4z"
            />
            <path
                fill={color}
                d="M0.1,77.8c0,0-0.1,0.3-0.1,0.5c0,0.2,0,0.4,0.1,0.5c0,0,0.1-0.1,0.2-0.5C0.1,77.9,0.1,77.7,0.1,77.8z"
            />
            <path
                fill={color}
                d="M0.4,53.3c0,0.2,0,0.4,0.1,0.4c0,0,0.1-0.1,0.1-0.2c0-0.2-0.1-0.4-0.1-0.5C0.4,53.1,0.4,53.2,0.4,53.3z"
            />
            <path
                fill={color}
                d="M0.5,50.8c0,0,0-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.3c0,0-0.1,0.2-0.1,0.4C0.5,50.7,0.5,50.8,0.5,50.8z"
            />
            <path
                fill={color}
                d="M0,56.1c0,0.2,0,0.3,0.1,0.5c0-0.2,0-0.3,0.1-0.6c0-0.2-0.1-0.3-0.1-0.4C0,55.7,0,55.9,0,56.1z"
            />
        </g>
    </svg>
);

VerticalLarge.propTypes = propTypes;
VerticalLarge.defaultProps = defaultProps;

export default VerticalLarge;
